import { render, staticRenderFns } from "./ads-block.vue?vue&type=template&id=62e51ed0&"
import script from "./ads-block.vue?vue&type=script&lang=js&"
export * from "./ads-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports